export const deviceContent = {
    es: {
        eyebrow: 'ECOSISTEMA CONECTADO',
        title: 'Funciona con todos tus dispositivos.',
    },
};
